"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateImageUrl = void 0;
/* istanbul ignore file -- maybe we should remove util function */

const updateImageUrl = data => {
  const {
    url,
    passPNG,
    jpgSettings
  } = data;
  if (!url) {
    return '';
  }
  if (passPNG) {
    const testUrl = url.toLowerCase();
    if (testUrl.includes('inputformat=png')) {
      return `${url}&imageFormat=png`;
    }
  }
  if (jpgSettings && jpgSettings.length > 0) {
    const settings = jpgSettings.join('&');
    return `${url}&${settings}`;
  }
  return url;
};
exports.updateImageUrl = updateImageUrl;
